import { EnrollmentStatus } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export const getReviewCardVisibility = (
  enrollmentStatus: EnrollmentStatus
): boolean =>
  $enum.mapValue(enrollmentStatus).with({
    [EnrollmentStatus.PENDING_ELECTION_WINDOW]: false,
    [EnrollmentStatus.ELECTION_ACTIVE]: false,
    [EnrollmentStatus.ELECTION_ACTIVE_HAS_NOT_STARTED]: false,
    [EnrollmentStatus.ELECTION_ACTIVE_STARTED]: false,
    [EnrollmentStatus.DEADLINE_PASSED]: true,
    [EnrollmentStatus.ELECTION_SUBMITTED]: true,
    [EnrollmentStatus.ENROLLMENT_IN_PROCESS]: true,
    [EnrollmentStatus.ENROLLMENT_CONFIRMED]: true,
    [EnrollmentStatus.ACTIVE_COVERAGE]: true,
    [EnrollmentStatus.COVERAGE_ENDED]: true,
    [EnrollmentStatus.WAIVED_ELECTION]: false,
    [EnrollmentStatus.WAIVED_COVERAGE]: false,
    [EnrollmentStatus.NO_ENROLLMENTS]: false,
  });
